module.exports = __webpack_public_path__ + "static/media/guideOverlay.0c77f950.png";